import { Box, Paper } from "@mui/material";
import Modal from "App/Components/Modals/Modal";
import Breadcrumb from "App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "App/Components/PageContainer/PageContainer";
import SortableTable from "App/Components/Table/SortableTable";
import { ModalType } from "App/Enums/ModalType";
import { useModalHooks } from "App/State/Hooks/useModalHooks";
import { FeatureFlags } from "App/Typings/FeatureFlags";
import { useFlags } from "launchdarkly-react-client-sdk";
import { AbacClientOverrideForm } from "./Components/AbacClientOverrideForm";
import AbacClientTableCell from "./Components/AbacClientTableCell";
import useAbacClientState from "./State/AbacClientState";

export default function AbacClientPage() {
  const {
    getters: {
      appName,
      selectedFeatureName,
      selectedDistributionType,
      draftDistribution,
      tableData,
      clientName,
      columns,
      isLoading,
      defaultDistribution,
      isSavingClientFeature,
    },
    handlers: {
      handleFeatureSelect,
      handleChangeModalDistributionType,
      handleUpdateDraftVariations,
      onSubmitClientFeature,
    },
  } = useAbacClientState();

  const { isModalTypeOpen, openModal } = useModalHooks();

  // Initialize EnableABACApplicationManagement LD flag
  // TODO: Remove with ABAC-32
  const { enableAbacApplicationManagement } = useFlags<FeatureFlags>();

  return (
    enableAbacApplicationManagement && (
      <>
        <PageContainer>
          <Breadcrumb pageTitle="Client Feature Variations" customBreadcrumbs={[]} />
          <h1 className="page-title">Manage {clientName} Feature Variations</h1>
          <Paper sx={{ mt: 4, p: { xs: 2, lg: 4 } }}>
            <Box
              sx={{
                pt: { xs: "3rem", sm: "unset" },
              }}
            >
              <SortableTable
                columns={columns}
                tableData={tableData}
                rowComponent={AbacClientTableCell}
                loading={isLoading}
                hideSearch={false}
                defaultSortIndex={0}
                setTableData={undefined}
                reverse={false}
                customProps={{
                  openModal: (featureId: string) => {
                    handleFeatureSelect(featureId);
                    openModal({
                      open: true,
                      type: ModalType.General,
                    });
                  },
                }}
              />
            </Box>
          </Paper>
          <Modal
            fullWidth
            maxWidth="md"
            open={isModalTypeOpen(ModalType.General)}
            title={`${appName}: ${selectedFeatureName}`}
            hasLoadingBar={true}
            isProcessing={isSavingClientFeature}
          >
            <AbacClientOverrideForm
              draftVariations={draftDistribution}
              defaultDistribution={defaultDistribution}
              selectedDistributionType={selectedDistributionType}
              handleChangeModalDistributionType={handleChangeModalDistributionType}
              handleUpdateDraftVariations={handleUpdateDraftVariations}
              onSubmit={onSubmitClientFeature}
            />
          </Modal>
        </PageContainer>
      </>
    )
  );
}
